import React, { useRef, useState } from "react";
import "./zoomimage.css";

function ZoomImage({ src, alt }) {
  const [backgroundPos, setBackgroundPos] = useState("0% 0%");
  const containerRef = useRef(null);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = containerRef.current.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setBackgroundPos(`${x}% ${y}%`);
  };

  return (
    <div
      ref={containerRef}
      className="zoom-container"
      onMouseMove={handleMouseMove}
    >
      <img src={src} alt={alt} />
      <div
        className="zoomed"
        style={{ backgroundImage: `url(${src})`, backgroundPosition: backgroundPos }}
      />
    </div>
  );
}

export default ZoomImage;